// extracted by mini-css-extract-plugin
module.exports = {"card":"selectionStartup_card__TlilD","location":"selectionStartup_location__1KO2z","tag":"selectionStartup_tag__RAs5H","result":"selectionStartup_result__1coNl"};